module.exports = __webpack_public_path__ + "static/media/number9.0a6b522f.svg";